export const LTO_STATS_API_PATHNAMES = {
  LTO_STATS_DATA: ({ startDate, endDate }) =>
    `payments/get/lto/usage/metrics?start_date=${startDate}&end_date=${endDate}`,
};
